module.exports = "https://img1.zhuanstatic.com/common/app_download/static/img/loading.5da366d1.svg";